<!-- Single wrapper that adapts based on group mode -->
<div
  [class.p-inputgroup]="group"
  [class.input-container]="!group"
  [style.display]="!group ? 'flex' : null"
  [style.align-items]="!group ? 'center' : null"
  [style.gap]="!group ? '8px' : null"
>
  <!-- Prepend (only in group mode) -->
  <span *ngIf="group && preLabel" class="p-inputgroup-addon">{{
    preLabel
  }}</span>
  <ng-container *ngIf="group && preContent && !preLabel">
    <span class="p-inputgroup-addon">
      <ng-content select="pre-content"></ng-content>
    </span>
  </ng-container>

  <!-- Input Text -->
  <input
    #inputModel="ngModel"
    #source="opInputSource"
    pInputText
    opInputSource
    class="form-control {{ inputClasses }}"
    [style.flex]="!group ? '1' : null"
    [style.border-radius]="!group ? '0.6rem' : null"
    [style.text-align]="textAlign"
    [style.font-size]="fontSize"
    [type]="type"
    [id]="key"
    [placeholder]="placeholder || ''"
    [ngModel]="value"
    (ngModelChange)="emitValue($event)"
    [name]="key ?? ''"
    [ngClass]="{
      'is-valid': isValid && !hasEqualError,
      'is-invalid': isInvalid || hasEqualError,
      'large-input': fontSize !== '1rem',
    }"
    [required]="required"
    [minlength]="minLength ?? null"
    [disabled]="disabled"
    [opValidateUnique]="validateUnique"
    [tkSlugify]="slugify !== undefined ? slugify : false"
    [validateField]="validateField"
    [validateElement]="validateElement"
    [autocomplete]="autocomplete"
    (keydown.enter)="onEnter()"
    (opSubmit)="onSourceSubmit($event)"
  />

  <!-- Append (only in group mode) -->
  <span *ngIf="group && postLabel" class="p-inputgroup-addon">{{
    postLabel
  }}</span>
  <ng-container *ngIf="group && postContent && !postLabel">
    <span class="p-inputgroup-addon">
      <ng-content select="post-content"></ng-content>
    </span>
  </ng-container>

  <!-- Clear Button (only in standalone mode) -->
  <op-button-ng
    *ngIf="!group && clearButton && value"
    icon="pi pi-times"
    color="danger"
    [asText]="true"
    (buttonClick)="clearValue()"
  />
</div>

<!-- Errors -->
<small class="text-danger">
  <ng-container
    *ngIf="
      required &&
      inputModel?.errors?.['required'] &&
      inputModel?.touched &&
      !inputModel?.errors?.['notUnique'] &&
      !hasEqualError
    "
  >
    {{ requiredError }}
  </ng-container>
  <ng-container
    *ngIf="
      minLength &&
      inputModel?.errors?.['minlength'] &&
      inputModel?.touched &&
      !inputModel?.errors?.['notUnique'] &&
      !hasEqualError
    "
  >
    {{
      minLengthError ||
        ('Minimum length is ' | translate) +
          minLength +
          (' characters' | translate)
    }}
  </ng-container>
  <ng-container
    *ngIf="
      inputModel?.errors?.['notUnique'] && inputModel?.touched && !hasEqualError
    "
  >
    {{ validateUniqueError || ('Value is not unique' | translate) }}
  </ng-container>
  <ng-container *ngIf="hasEqualError">
    {{ validateEqualError || ('Values do not match' | translate) }}
  </ng-container>
</small>
